/**
 * The track under a click on one frame of the analysed clip, or null. `p` is the click in source pixels
 * (tracks.json), `margin` the handle in source pixels (a few CSS pixels at the zoom shown) that lets a click just
 * off a mark still land on it.
 *
 * The target is the mark the person sees, whichever tool is active: with `onDot` (the dots view) the dot itself
 * plus the margin, else (the boxes view) the box plus the margin, the nearest center first when boxes overlap. Never
 * a circle sized by the box's longer side, which on a packed herd reaches the animals lying beside a tracked one:
 * in the dots view a click on an animal beside a dotted one adds it, a click on the dot opens the track's menu or
 * removes it.
 */
export const pickTrack = (index, frame, p, { margin = 0, onDot = false } = {}) => {
	if (!index?.perFrame || !p || !Number.isFinite(frame)) return null;
	const f = Math.min(index.nFrames - 1, Math.max(0, Math.floor(frame)));
	let best = null;
	for (let i = index.perFrame[f]; i < index.perFrame[f + 1]; i += 1) {
		const tr = index.tracks[index.trackOf[i]];
		const j = index.pointOf[i];
		const dx = Math.abs(p[0] - tr.x[j]);
		const dy = Math.abs(p[1] - tr.y[j]);
		const d = Math.hypot(dx, dy);
		const hit = onDot ? d <= margin : dx <= tr.w[j] / 2 + margin && dy <= tr.h[j] / 2 + margin;
		if (hit && (!best || d < best.d)) best = { d, tr, j };
	}
	if (!best) return null;
	return { id: best.tr.id, frame: f, x: best.tr.x[best.j], y: best.tr.y[best.j] };
};
